<template>
  <vx-card v-if="user">
    <div class="mt-5">
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        :title="wizardOptions.title"
        :subtitle="null"
        @on-change="changeTab"
        ref="formWizard"
      >
        <tab-content title="登録区分の選択" class="mb-5 mt-10">
          <tab-select-license-category />
        </tab-content>

        <tab-content title="資格情報の入力" class="mb-5">
          <div v-if="selectedLicenseCategory === licenseCategory.BOAT">
            <tab-boat-license ref="tabBoatLicense"></tab-boat-license>
          </div>
          <div v-else-if="selectedLicenseCategory === licenseCategory.MARINE">
            <tab-marine-license ref="tabMarineLicense"></tab-marine-license>
          </div>
          <div v-else-if="selectedLicenseCategory === licenseCategory.OTHERS">
            <tab-others-license ref="tabOthersLicense"></tab-others-license>
          </div>
        </tab-content>

        <tab-content title="登録完了" class="mb-5">
          <tab-complete @reset="reset" />
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <span role="button" tabindex="0"
              ><button
                v-if="props.activeTabIndex == 1"
                type="button"
                @click="props.prevTab()"
                class="wizard-btn"
                :style="props.fillButtonStyle"
              >
                戻る
              </button></span
            >
          </div>
          <div class="wizard-footer-right">
            <span role="button" tabindex="0"
              ><button
                v-if="props.activeTabIndex == 1"
                type="button"
                @click="onClickRegister"
                class="wizard-btn"
                :style="props.fillButtonStyle"
              >
                登録する
              </button></span
            >
          </div>
        </template>
      </form-wizard>
    </div>
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import TabSelectLicenseCategory from "./tabs/tabSelectLicenseCategory";
import TabBoatLicense from "./tabs/tabBoatLicense";
import TabOthersLicense from "./tabs/tabOthersLicense";
import TabMarineLicense from "./tabs/tabMarineLicense";
import TabComplete from "./tabs/tabComplete";
import LicenseMixin from "@/mixins/LicenseMixin";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseLicenseAdd"
);

export default {
  components: {
    FormWizard,
    TabContent,
    TabSelectLicenseCategory,
    TabBoatLicense,
    TabMarineLicense,
    TabOthersLicense,
    TabComplete
  },
  mixins: [LicenseMixin],
  data() {
    return {
      wizardOptions: {
        title: ""
      },
      wizardTitle: {
        selectCategory: {
          title: "登録する資格区分を選択してください"
        },
        input: {
          title: [
            "小型船舶免許情報を教えてください",
            "海技士免状情報を教えてください",
            "登録する免許、または資格の情報を教えてください"
          ]
        },
        complete: {
          title: "登録が完了しました"
        }
      }
    };
  },
  watch: {
    selectedLicenseCategory(newValue, _oldValue) {
      if (newValue !== null) {
        this.$refs.formWizard.nextTab();
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedLicenseCategory: state => state.selectedLicenseCategory
    })
  },
  methods: {
    ...mapActions([
      "fetchUserData",
      "registerLicense",
      "setSelectedLicenseCategory",
      "cleanUp",
      "resetLicenseAddState"
    ]),

    changeTab(prevIndex, nextIndex) {
      if (!this.user) return
      if (nextIndex === 0 || nextIndex === -1) {
        this.setSelectedLicenseCategory(null);
          this.wizardOptions.title =
            ( this.user.name || this.user.name_en ) + ' ' + this.wizardTitle.selectCategory.title;
      }
      if (nextIndex === 1) {
        this.wizardOptions.title =
          ( this.user.name || this.user.name_en ) + ' ' +
          this.wizardTitle.input.title[this.selectedLicenseCategory];
        this.$refs.formWizard.reset();
      }
      if (nextIndex === 2) {
        this.wizardOptions.title = this.wizardTitle.complete.title;
      }
    },

    async reset() {
      this.$refs.formWizard.reset();
      await this.resetLicenseAddState();
      await this.fetchUserData({ userId: this.$route.params.userId });
    },

    validateForm() {
      switch (this.selectedLicenseCategory) {
        case this.licenseCategory.BOAT:
          return this.$refs.tabBoatLicense.validate();
        case this.licenseCategory.MARINE:
          return this.$refs.tabMarineLicense.validate();
        case this.licenseCategory.OTHERS:
          return this.$refs.tabOthersLicense.validate();
      }
    },

    async onClickRegister() {
      let result = await this.validateForm();
      if (result) {
        this.$vs.loading();
        let payload = {
          userId: this.$route.params.userId
        };
        try {
          await this.registerLicense(payload);
          this.$vs.loading.close();
          this.successRegister();
        } catch (e) {
          this.$vs.loading.close();
          this.failureRegister(e);
        }
      }
    },

    successRegister() {
      this.$refs.formWizard.nextTab();
      this.$vs.notify({
        color: "success",
        title: "資格の登録に成功しました"
      });
    },

    failureRegister() {
      this.$vs.notify({
        color: "danger",
        title: "資格の登録に失敗しました"
      });
    },

    cleanup() {
      this.resetLicenseAddState();
    }
  },
  async created() {
    await this.fetchUserData({ userId: this.$route.params.userId });
    this.wizardOptions.title =
      ( this.user.name || this.user.name_en ) + ' ' + this.wizardTitle.selectCategory.title;
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
.vs-button {
  .text-small {
    font-size: small;
  }
}
</style>
